import {ScaleResult} from "./scale-result";
import {Assessment} from "./assessment";
import {QuestionSet} from "./question-set";
import {Question} from "./question";

export class AssessmentResult {
	private _id:string;
	private _assignmentItemId:number;
	private _assessment:Assessment;
	private _scaleResults:ScaleResult[];
	private _flaggedQuestions:Question[];
	
	constructor() {
		this._scaleResults = [];
	}
	
	public get assignmentItemId() : number {
		return this._assignmentItemId;
	}

	public set assignmentItemId(v:number) {
		this._assignmentItemId = v;
	}
	public get id() :string {
		return this._id;
	}
	
	public set id(v:string) {
		this._id = v;
	}
	
	public get assessment() : Assessment {
		return this._assessment;
	}
	
	public set assessment(v : Assessment) {
		this._assessment = v;
	}
	
	
	public get scaleResults() : ScaleResult[] {
		return this._scaleResults;
	}
	
	public set scaleResults(v : ScaleResult[]) {
		this._scaleResults = v;
	}
	
	public get hasResources() : boolean {
		return this.assessment.resourcesURL && this.assessment.resourcesURL != ""; 
	}
	
	public get hasHomework() : boolean {
		return this.scaleResults.some(this.scaleHasHomework);
	}
	
	public getScalesWithHomework() : ScaleResult[] {
		return this.scaleResults.filter(this.scaleHasHomework);
	}

	public get flaggedQuestions(): Question[] {
		return this._flaggedQuestions;
	}

	public set flaggedQuestions(value: Question[]) {
		this._flaggedQuestions = value;
	}
	
	public getScaleResultByScaleId(scaleId:string) :  ScaleResult {
		// TODO: stephen optimize this later.
		let results:ScaleResult[] = this.scaleResults.filter(s => {
			return s.scale != null && s.scale.id === scaleId;
		});
		if (results.length) {
			return results[0];
		}
		
		return null;
	}
	
	private scaleHasHomework(scaleResult:ScaleResult) : boolean {
		return scaleResult.range && 
			scaleResult.range.assignmentURL != null && 
			scaleResult.range.assignmentURL != null && 
			scaleResult.range.assignmentURL != "";
	}
}


// WEBPACK FOOTER //
// ./src/app/shared/models/assessment-result.ts